// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__3mti3","load2":"Spinner_load2__16jUQ"};